// extracted by mini-css-extract-plugin
module.exports = {"layout":"PromoCode_layout__380ho","form":"PromoCode_form__1jXgA","field":"PromoCode_field__Dtbk_","input":"PromoCode_input__11B-N"};